import { formatPrice } from '@helpers/payment'
import { useCheckoutContext } from '@pages/Checkout/routes/contexts'
import { Paragraph, Spacer } from '@ui-kit'
import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import { Row } from 'simple-flexbox'

export const VatAmount = ({ vatAmount }: { vatAmount: number }) => {
  const { t } = useTranslation()

  const { accountCurrency } = useCheckoutContext()

  return (
    <Fragment>
      <Spacer space={15} />

      <Row justifyContent='space-between'>
        <Paragraph>{t('word.vat.twenty.three.percent')}</Paragraph>

        <Paragraph>
          {formatPrice(vatAmount)} {accountCurrency}
        </Paragraph>
      </Row>

      <Spacer space={15} />
    </Fragment>
  )
}
